import { useEffect, useState } from 'react';
import { getStorageAdapater, StorageFolder } from '../firebase/StorageAdapater';
import { set } from 'lodash';

type ListStorageReturn = {
    folderContent: StorageFolder;
    refreshFolder: () => Promise<void>;
};
export const useListStorageFolder = (path: string) => {
    const [folderContent, setFolderContent] = useState<StorageFolder>(null);
    const [isLoading, setIsLoading] = useState(true);

    const refreshFolder = async () => {
        const adapter = getStorageAdapater();
        const folder = await adapter.getListFolderContent(path);
        setIsLoading(false);
        setFolderContent(folder);
    };
    useEffect(() => {
        refreshFolder();
    }, [path]);

    return { folderContent, refreshFolder, isLoading };
};
